import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Ofertas especiais',
  view_more: 'Ver mais',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Promoção',
    'FREE ITEM': 'Item gratuito',
    REWARDS: 'Recompensas',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} Pontos Extra',
      description: 'Avalie-nos no Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Promoção especial',
      description: 'Já aplicado automaticamente',
    },
    buttons: {
      add: 'Adicionar',
      remove: 'Remover',
      show_details: 'Ver detalhes',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} de Bónus de Registo na App',
      desc: 'Obtenha {{amount}} de cashback ao iniciar sessão na nossa app.',
    },
    welcome_bonus: {
      title: '{{amount}} de Bónus de Boas-Vindas',
      desc: 'Obtenha {{amount}} de cashback ao registar-se.',
    },
  },
  discounts: {
    title: '{{discount}} de desconto',
    usage_threshold: '(Mín.: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} de desconto na sua próxima encomenda — código: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]:
        '{{discount}} de desconto nas suas próximas {{count}} encomendas — código: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Inicie sessão</highlight> para usar esta promo e garantirmos que ainda não a utilizou. Inicie sessão e tente novamente.',
  },
};
